import React from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import Cardto from './../Cardto.js';


class Devoir extends React.Component{
  render(){
    return(
      <div>
          <Alert variant="info">
            <h3>
              Dovoir des maths + correction (PDF) pour tous les nivaux
            </h3>
          </Alert>

          <Row>
              <Cardto
              title="1er année secondaire"
              ty="Devoir"
              color1="#f28c8c"
              content=""
              fileUrl="/documents/243517.pdf"
              linkto="/maths/1/devoirs" />

              <Cardto
              title="2ème année secondaire"
               ty="Devoir"
               color1="#f28c8c"
               content=""
               fileUrl="/documents/243517.pdf"
               linkto="/maths/2/devoirs" />

              <Cardto
              title="3ème année secondaire"
              ty="Devoir"
              color1="#f28c8c"
              content=""
              fileUrl="/documents/243517.pdf"
              linkto="/maths/3/devoirs"/>
          </Row>

          <Row>
              <Cardto
              title="1er anné Bac"
              ty="Devoir"
              color1="#f28c8c"
              content=""
              fileUrl="/documents/243517.pd"
              linkto="/maths/4/devoirs" />

              <Cardto
              title="2ème anné Bac"
              ty="Devoir"
              color1="#f28c8c"
              content=""
              fileUrl="/documents/243517.pd"
              linkto="/maths/5/devoirs" />


              <Cardto
              title="Tranc commun"
              ty="Devoir"
              color1="#f28c8c"
              content=""
              fileUrl="/documents/243517.pd"
              linkto="/maths/6/devoirs" />
          </Row>


      </div>
    );
  }
}

export default Devoir;
